import mapData from "lib/stores/mapData";
import { getProductPoints, getBoundingBox, fitBounds } from "lib/map/functions";

export default function onChangeSelectedProducts(deckRef) {
  if (!mapData.selectedProduct || !mapData.productsCountry) return;
  try {
    const points = getProductPoints();
    const bounds = getBoundingBox(points);
    const fittedBounds = fitBounds(bounds, deckRef.current.deck.width, deckRef.current.deck.height);
    mapData.viewState = {
      ...mapData.viewState,
      ...fittedBounds,
      pitch: 40,
      bearing: 0
    };
  } catch (error) {
  }
}
